import { useMemo, useRef, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../redux/hooks'
import { toggleMenu } from '../../redux/slices/burgerMenuSlice'
import { RootState } from '../../redux/store'
import { useOutsideClick } from '../../hooks/useOutsideClick'
import { ModalType } from '../../core/enums/Modals'

const BottomMenu = () => {
	const location = useLocation()
	const [circleSpread, setCircleSpread] = useState(false)
	const [activeButton, setActiveButton] = useState<string | null>(null)
	const dispatch = useAppDispatch()
	const { active } = useAppSelector((state: RootState) => state.burger)
	const messages = useAppSelector((state: RootState) => state.inbox.messages)
	const promoRef = useRef(null)

	useOutsideClick(
		promoRef,
		() => {
			setCircleSpread(false)
			setActiveButton('')
		},
		ModalType.Promo,
	)

	const unreadMessagesCount = useMemo(() => {
		return messages.filter((message: { read: any }) => !message.read).length
	}, [messages])

	const handleSpreadCircles = () => {
		setCircleSpread(!circleSpread)
		if (activeButton !== 'promo') {
			handleButtonClick('promo')
		} else {
			setActiveButton(null)
		}
	}

	const handleButtonClick = (buttonName: string) => {
		setActiveButton((prevButton) => (prevButton === buttonName ? null : buttonName))
		if (buttonName === 'burger') {
			dispatch(toggleMenu())
		}
	}

	const handlePromoClick = () => {
		setCircleSpread(false)
		setActiveButton(null)
	}

	const isVIPActive = location.pathname === '/vip'
	const isProfileActive = location.pathname === '/profile'
	const isInboxActive = location.pathname === '/inbox'

	if (location.pathname.includes('/game/')) {
		return null
	}

	return (
		<div className="bottom-menu">
			<div
				className={`bottom-menu-item burger ${active ? 'pressed' : ''}`}
				onClick={() => {
					handleButtonClick('burger')
				}}
			>
				<div className="icon"></div>
				<div className="text">Menu</div>
			</div>
			<Link to="/vip" className={`bottom-menu-item vip ${isVIPActive ? 'pressed' : ''}`} onClick={() => handleButtonClick('vip')}>
				<div className="icon"></div>
				<div className="text">VIP</div>
			</Link>
			<div ref={promoRef} className={`bottom-menu-item promo ${activeButton === 'promo' ? 'pressed' : ''}`} onClick={() => handleSpreadCircles()}>
				<div className="icon"></div>
				<div className="text">Promos</div>
			</div>
			<Link to="/inbox" className={`bottom-menu-item inbox ${isInboxActive ? 'pressed' : ''}`} onClick={() => handleButtonClick('inbox')}>
				{unreadMessagesCount > 0 && <div className="unread-messages-counter">{unreadMessagesCount}</div>}
				<div className="icon"></div>
				<div className="text">Inbox</div>
			</Link>
			<Link to="/profile" className={`bottom-menu-item profile ${isProfileActive ? 'pressed' : ''}`} onClick={() => handleButtonClick('profile')}>
				<div className="icon"></div>
				<div className="text">Profile</div>
			</Link>
			<Link
				to="/tournament-list"
				className={`popping-circle tournaments ${activeButton === 'promo' ? 'spread' : ''}`}
				onClick={() => {
					handlePromoClick()
				}}
			></Link>
			<Link
				to="/missions"
				className={`popping-circle missions ${activeButton === 'promo' ? 'spread' : ''}`}
				onClick={() => {
					handlePromoClick()
				}}
			></Link>
			<Link
				to="/mini-games"
				className={`popping-circle minigames ${activeButton === 'promo' ? 'spread' : ''}`}
				onClick={() => {
					handlePromoClick()
				}}
			></Link>
		</div>
	)
}

export default BottomMenu
